import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View`
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden;
  width: 100%;
`;

export const Toast = styled.View`
  background-color: rgba(89, 192, 11, 0.9);
  margin: 20px 8px;

  position: relative;

  align-items: center;
  padding: 12px;
  border-radius: 6px;
`;

export const ToastText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot1};
`;
